import { render, staticRenderFns } from "./salary.vue?vue&type=template&id=69fb9593&scoped=true&"
import script from "./salary.vue?vue&type=script&lang=js&"
export * from "./salary.vue?vue&type=script&lang=js&"
import style0 from "./salary.vue?vue&type=style&index=0&id=69fb9593&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fb9593",
  null
  
)

export default component.exports